import { Box, Stepper, styled } from '@mui/material';

const ScrollableContainer = styled(Box, {
  shouldForwardProp: prop => prop !== 'isExpanded' && prop !== 'fixedHeight',
})<{ isExpanded?: boolean; fixedHeight?: number }>(({ isExpanded, fixedHeight }) => ({
  ...(fixedHeight
    ? { height: `${fixedHeight}px`, overflowY: 'auto' as const }
    : { height: isExpanded ? '420px' : '270px', overflowY: isExpanded ? 'visible' as const : 'auto' as const }),
  overflowX: 'hidden',
  width: '100%',
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  '&::-webkit-scrollbar': {
    width: '6px',
  },
  '&::-webkit-scrollbar-track': {
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    background: '#ccc',
    borderRadius: '3px',
    '&:hover': {
      background: '#999',
    },
  },
}));

const StyledStepper = styled(Stepper)({
  width: '100%',
  '& .MuiStep-root': {
    padding: 0,
    '& .MuiStepLabel-root': {
      padding: 0,
    },
  },
  '& .MuiStepConnector-line': {
    minHeight: 16,
  },
});

export { ScrollableContainer, StyledStepper };
